<template>
  <b-card>
    <FormBuilder
      label="Voucher"
      create
      :fields="fields"
      :loading-submit="$store.state.voucher.loadingSubmit"
      @submit="submitData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/voucher'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    submitData(data, callback) {
      this.$store.dispatch('voucher/create', data)
        .then(callback)
    },
  },
}
</script>

<style scoped>

</style>
